<script setup>
import AppButton from '#/general/AppButton'
import { ref, defineAsyncComponent } from 'vue'
const DetailsReportDemo = defineAsyncComponent(() => import('components/home/DetailsReportDemo'))

const showDetailsReportDemo = ref(false)
</script>

<template lang="pug">
.explanation--container
  details-report-demo(v-model:visible="showDetailsReportDemo")
  .routerPageSize
    .explanation--content
      .explanation--title
        | Werden auch Sie
        br
        | ein
        strong &#32; Raumpionier. &#32;
      .explanation--text
        | Sie planen, Ihre Liegenschaft an die nächste Generation weiterzugeben? Oder möchten ganz einfach ihr volles ökonomisches Potenzial ausschöpfen? Dann sind Sie hier genau richtig!  Als innovativer Immobilienentwickler helfen wir
        strong &#32; Raumpioniere &#32;
        | Ihnen nicht nur das verborgene Potenzial Ihrer Liegenschaft aufzudecken, sondern dieses auch gleich zu realisieren.
      .explanation--subtitle Und so einfach geht’s:
      .explanation--steps
        .explanation--step
          .explanation--step-svg
            svg(width='200' height='233' viewBox='0 0 200 233' fill='none' xmlns='http://www.w3.org/2000/svg')
              g(clip-path='url(#clip0_7019_11410)')
                path(d='M44.8899 129.138V90.6707L68.4999 105.034L65.4499 143.081L44.8899 129.138Z' fill='#5FEFC0')
                path(d='M132.67 1.32251V27.7279L157.43 45.9516L166.68 17.2157L132.67 1.32251Z' fill='#5FEFC0')
                path(d='M166.68 17.2158L138.99 103.203' stroke='#C8C8C8' stroke-width='2' stroke-linejoin='round')
                path(d='M176.56 117.376L132.67 101.203L88.78 117.376L44.89 90.6707L1 93.5412' stroke='#C8C8C8' stroke-width='2' stroke-linejoin='round')
                path(d='M68.5 105.034L62.54 179.469' stroke='#C8C8C8' stroke-width='2' stroke-linejoin='round')
                path(d='M1 143.081L44.89 129.138L65.45 143.081' stroke='#C8C8C8' stroke-width='2' stroke-linejoin='round')
                path(d='M176.56 191.731L132.67 171.227V1.32251L176.56 21.8267V191.731Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M20.15 60.0144L1 64.0352' stroke='#C8C8C8' stroke-width='2' stroke-linejoin='round')
                path(d='M20.1499 92.2909V60.0144L44.8899 43.0109L88.7799 73.4471L115.09 45.9515L132.67 27.7278L157.43 45.9515' stroke='#C8C8C8' stroke-width='2' stroke-linejoin='round')
                path(d='M132.67 171.227L88.78 191.731V21.8267L132.67 1.32251V171.227Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M88.7799 191.731L44.8899 171.227V1.32251L88.7799 21.8267V191.731Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M144.93 151.433L196.5 215.076C198.99 218.147 198.52 222.648 195.45 225.138L189.74 229.769C186.67 232.26 182.17 231.789 179.68 228.719L128.11 165.076' fill='white')
                path(d='M144.93 151.433L196.5 215.076C198.99 218.147 198.52 222.648 195.45 225.138L189.74 229.769C186.67 232.26 182.17 231.789 179.68 228.719L128.11 165.076' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M153.19 98.1723C135.53 76.3778 103.56 73.0371 81.7899 90.7007C60.0099 108.364 56.6799 140.351 74.3399 162.145C91.9999 183.94 123.97 187.28 145.74 169.617C167.52 151.953 170.85 119.967 153.19 98.1723ZM136.37 158.064C120.97 170.557 98.3699 168.187 85.8799 152.783C73.3899 137.37 75.7499 114.756 91.1499 102.263C106.55 89.7705 129.15 92.141 141.64 107.544C154.13 122.957 151.77 145.572 136.37 158.064Z' fill='white' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(opacity='0.75' d='M120.039 165.517C139.555 162.053 152.569 143.413 149.104 123.881C145.64 104.349 127.01 91.3232 107.493 94.7864C87.9765 98.2495 74.9634 116.89 78.4278 136.422C81.8921 155.954 100.522 168.98 120.039 165.517Z' fill='#063CEF' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M44.89 171.227L1 191.731V21.8267L44.89 1.32251V171.227Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
              defs
                clipPath#clip0_7019_11410
                  rect(width='199.1' height='232.047' fill='white' transform='translate(0 0.322266)')
          .explanation--step-title Schritt 1
          .explanation--step-subtitle Potenzial aufdecken
          .explanation--step-text Geben Sie Ihre Adresse ein und kommen Sie mit ein paar wenigen Klicks zu einer zuverlässigen Erstindikation zum Potenzial Ihrer Liegenschaft.
          .explanation--step-btn(@click="showDetailsReportDemo  = !showDetailsReportDemo") Jetzt Demo-Report ansehen
        .explanation--step
          .explanation--step-svg
            svg(width='201' height='233' viewBox='0 0 201 233' fill='none' xmlns='http://www.w3.org/2000/svg')
              g(clip-path='url(#clip0_7019_11427)')
                path(d='M59.0441 68.7534L26.916 80.4495L38.6097 112.584L70.7378 100.888L59.0441 68.7534Z' fill='#5FEFC0')
                path(d='M76.8586 117.7L44.7305 129.396L56.4241 161.531L88.5522 149.835L76.8586 117.7Z' fill='#5FEFC0')
                path(d='M94.6857 166.664L62.5576 178.36L74.2513 210.494L106.379 198.798L94.6857 166.664Z' fill='#5FEFC0')
                path(d='M135.245 5.40687L1.00977 54.2744L65.4532 231.367L199.688 182.5L135.245 5.40687Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M57.9299 63.385L33.4199 72.2968L44.3299 102.273L74.2999 91.3607L70.2899 80.3485' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M78.3401 58.4742L120.47 43.1411' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M81.8401 68.1061L112.59 56.9138' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M45.75 82.0189L57.23 87.38L68.82 62.5249' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M75.8201 112.545L51.3201 121.457L62.2301 151.433L92.2001 140.521L88.1901 129.509' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M96.23 107.634L138.37 92.301' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M99.74 117.266L130.48 106.074' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M63.6399 131.179L75.1199 136.54L86.7099 111.685' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M93.72 161.695L69.21 170.617L80.12 200.593L110.09 189.681L106.08 178.669' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M114.13 156.794L156.26 141.461' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M117.63 166.426L148.38 155.234' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M81.53 180.339L93.02 185.7L104.6 160.845' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M31.7959 23.4819L91.8422 1.62239C94.4358 0.678218 97.3068 2.01728 98.2508 4.61136L105.245 23.832L35.8018 49.1124L28.8075 29.8918C27.8635 27.2977 29.2023 24.4261 31.7959 23.4819Z' fill='white' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M131.76 142.941L172.99 48.5921C174.98 44.0412 180.28 41.9608 184.83 43.9512L193.3 47.6519C197.85 49.6424 199.93 54.9434 197.94 59.4944L156.71 153.844L132.13 176.098L131.76 142.941Z' fill='white' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                g(opacity='0.75')
                  path(d='M163.98 69.2064L172.99 48.5921C174.98 44.0412 180.28 41.9608 184.83 43.9512L193.3 47.6519C197.85 49.6424 199.93 54.9434 197.94 59.4944L188.93 80.1086' fill='#063CEF')
                  path(d='M163.98 69.2063L172.99 48.5921C174.98 44.0412 180.28 41.9608 184.83 43.9512L193.3 47.6519C197.85 49.6424 199.93 54.9434 197.94 59.4944L188.93 80.1086' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M156.71 153.844L131.76 142.941' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M188.93 80.1085L163.98 69.2063' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
              defs
                clipPath#clip0_7019_11427
                  rect(width='200.69' height='232.047' fill='white' transform='translate(0 0.322266)')
          .explanation--step-title Schritt 2
          .explanation--step-subtitle Gemeinsame Strategie entwickeln
          .explanation--step-text Auf Basis der Erstindikation finden wir gemeinsam mit Ihnen die ideale Vorgehensweise, um passend zu Ihrer Ausgangslage das Potenzial Ihrer Liegenschaft optimal auszuschöpfen.
        .explanation--step.building--step
          .explanation--step-svg.building-svg
            svg(width='192' height='245' viewBox='0 0 192 245' fill='none' xmlns='http://www.w3.org/2000/svg')
              g(clip-path='url(#clip0_7019_11476)')
                path(d='M152.83 152.653L190.92 179.029L95.96 244.782L1 179.029L39.09 152.653V166.716L95.96 206.094L152.83 166.716V152.653Z' fill='#5FEFC0')
                path(d='M39.09 141.781L1 168.156L95.96 233.91L190.92 168.156L152.83 141.781' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M95.9601 206.094L39.0901 166.716V119.467L95.9601 158.845V206.094Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M95.96 158.845V206.094L152.83 166.716V119.467V87.9602L118.71 111.585V143.091L95.96 158.845Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M107.33 198.223V166.716L118.71 158.845V190.351L107.33 198.223Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M130.08 150.963V166.716L141.45 158.845V143.091L130.08 150.963Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M130.08 135.21V119.467L141.45 111.585V127.338L130.08 135.21Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M39.0901 119.467L61.8401 103.713L118.71 143.091L95.9601 158.845L39.0901 119.467Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M61.8401 103.713V72.207L118.71 111.585V143.091L61.8401 103.713Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M61.8401 72.2069L95.9601 48.582L152.83 87.9601L118.71 111.585L61.8401 72.2069Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(opacity='0.75' d='M152.83 87.9601V40.7004L95.96 80.0785V158.845L118.71 143.091V111.585L152.83 87.9601Z' fill='#063CEF' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(opacity='0.75' d='M39.0901 119.467V40.7004L95.9601 80.0785V158.845L39.0901 119.467Z' fill='#063CEF' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(opacity='0.75' d='M152.83 40.7005L95.9601 80.0786L39.0901 40.7005L95.9601 1.32251L152.83 40.7005Z' fill='#063CEF' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
              defs
                clipPath#clip0_7019_11476
                  rect(width='191.92' height='244.46' fill='white' transform='translate(0 0.322266)')
          .explanation--step-title Schritt 3
          .explanation--step-subtitle
            div Projekt
            div realisieren
          .explanation--step-text Sind die Rahmenbedingungen klar festgelegt, steht einer erfolgreichen partnerschaftlichen Entwicklung Ihres Projekts nichts mehr im Weg.
      .explanation--submit-container
        app-button.explanation--submit(label="Jetzt Potenzial prüfen" @clicked="$emit('openAnalyzer')")
</template>

<style scoped lang="sass">
.explanation--container
  width: 100%
  display: flex
  justify-content: center
  @media screen and (min-width: 1024px)
    padding-bottom: 135px
  .explanation--content
    display: flex
    flex-direction: column
    align-items: center
    position: relative
    color: #22223C
    @media screen and (min-width: 1024px)
      margin-top: 135px
    @media screen and (max-width: 1024px)
      margin-top: 43px
    .explanation--title
      font-weight: 500
      line-height: 130%
      text-align: center
      @media screen and (min-width: 1024px)
        margin-bottom: 70px
        font-size: 55px
      @media screen and (max-width: 1024px)
        margin-bottom: 35px
        font-size: 30px
    .explanation--text
      line-height: 150%
      text-align: center
      max-width: 873px
      @media screen and (min-width: 1024px)
        font-size: 20px
        margin-bottom: 101px
      @media screen and (max-width: 1024px)
        font-size: 16px
        margin-bottom: 48px
    .explanation--subtitle
      font-weight: 500
      line-height: 130%
      text-align: center
      color: #22223C
      @media screen and (min-width: 1024px)
        font-size: 34px
        margin-bottom: 175px
      @media screen and (max-width: 1024px)
        font-size: 24px
        margin-bottom: 118px
    .explanation--steps
      @media screen and (min-width: 1024px)
        display: grid
        grid-template-columns: 1fr 1fr 1fr
        grid-gap: 36px
      @media screen and (max-width: 1024px)
      .building--step
        @media screen and (max-width: 1024px)
          margin-top: 161px
          margin-bottom: 0px !important
      .explanation--step
        padding: 30px
        position: relative
        width: 100%
        background: #F6F7FA
        backdrop-filter: blur(5px)
        border-radius: 10px
        @media screen and (min-width: 1024px)
        @media screen and (max-width: 1024px)
          margin-bottom: 131px
        .building-svg
          @media screen and (max-width: 1024px)
            top: -125px !important
        .explanation--step-svg
          position: absolute
          @media screen and (min-width: 1024px)
            top: -100px
            left: 115px
          @media screen and (max-width: 1024px)
            top: -90px
            left: calc(50% - 77px)
          svg
            @media screen and (min-width: 1024px)
              width: 200px
              height: 230px
            @media screen and (max-width: 1024px)
              width: 154px
              height: 180px
        .explanation--step-title
          font-weight: 700
          line-height: 130%
          color: #1F47CD
          margin-bottom: 18px
          @media screen and (min-width: 1024px)
            margin-top: 120px
            font-size: 20px
          @media screen and (max-width: 1024px)
            margin-top: 70px
            font-size: 16px
        .explanation--step-subtitle
          font-weight: 500
          line-height: 125%
          background: linear-gradient(152.99deg, #2F3849 24.83%, #21252E 103.84%)
          -webkit-background-clip: text
          -webkit-text-fill-color: transparent
          text-fill-color: transparent
          margin-bottom: 18px
          @media screen and (min-width: 1024px)
            font-size: 34px
          @media screen and (max-width: 1024px)
            font-size: 24px
        .explanation--step-text
          line-height: 150%
          color: #22223C
          margin-bottom: 18px
          @media screen and (min-width: 1024px)
            font-size: 20px
            font-weight: 400
          @media screen and (max-width: 1024px)
            font-size: 16px
        .explanation--step-btn
          font-weight: 600
          color: #1F47CD
          cursor: pointer
          display: flex
          justify-content: center
          align-items: center
          border: 1px solid #1F47CD
          border-radius: 10px
          width: 100%
          height: 54px
          transition: all 0.3s ease-in-out
          @media screen and (min-width: 1024px)
            font-size: 20px
            line-height: 30px
          @media screen and (max-width: 1024px)
            font-size: 16px
            margin-top: 30px
          &:hover
            background: #1F47CD !important
            color: white !important
    .explanation--submit-container
      width: 100%
      display: flex
      justify-content: center
      .explanation--submit
        background: #1F47CD
        border-radius: 10px
        padding: 0 46px
        @media screen and (min-width: 1024px)
          margin-top: 48px
          font-size: 20px !important
        @media screen and (max-width: 1024px)
          margin: 29px 0 33px
          font-size: 16px !important
</style>
